import React from "react";
import { Navigate, NavigateProps, useSearchParams } from "react-router-dom";

function NavigateWithParams({ to, ...props }: NavigateProps) {
  const [searchParams] = useSearchParams();

  return <Navigate {...props} to={`${to}?${searchParams.toString()}`} />;
}

export default NavigateWithParams;
